export const shadesofcitrus = {
  name: 'Shades of Citrus',
  color: [0.9764705882352941, 0.8627450980392157, 0.1411764705882353, 1],
  bg: [0.9215686274509803, 0.5411764705882353, 0.26666666666666666, 1],
  grid1: [0.29411764705882354, 0.4549019607843137, 0.2784313725490196, 1],
  grid2: [0.6352941176470588, 0.7725490196078432, 0.13725490196078433, 1],
}
